export const ROUTE_LOGIN = '/'
export const ROUTE_DASHBOARD = '/dashboard'
export const ROUTE_MENU = '/menu'
export const ROUTE_BOXES = '/boxes'
export const ROUTE_ADDSONGS = '/addsongs'
export const ROUTE_PLAYLISTS = '/playlists'
export const ROUTE_PLAYLIST = '/playlists/:id'
export const ROUTE_PLAYLIST_CREATE = '/playlists/create'
export const ROUTE_PLAYLIST_EDIT = '/playlists/edit/:id'
export const ROUTE_PLAYLIST_SCHEDULE = '/playlist-schedule'
export const ROUTE_PLAYLIST_SCHEDULE_ADD = '/playlist-schedule/add'
export const ROUTE_PLAYLIST_SCHEDULE_EDIT = '/playlist-schedule/:id'
export const ROUTE_JINGLES = '/jingles'
export const ROUTE_JINGLE_TUNING = '/jingles/tuning'
export const ROUTE_JINGLE_SCHEDULE = '/jingle-schedule'
export const ROUTE_JINGLE_SCHEDULE_ADD = '/jingle-block/add'
export const ROUTE_JINGLE_SCHEDULE_EDIT = '/jingle-block/:id'
export const ROUTE_JUKEBOX = '/jukebox'
export const ROUTE_REPORTS = '/reports'
export const ROUTE_HELP = '/help'



// WEBPACK FOOTER //
// ./src/const/routeNames.js